import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=5693c273&scoped=true&"
import script from "./Convenios.vue?vue&type=script&lang=js&"
export * from "./Convenios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5693c273",
  null
  
)

export default component.exports